"use strict";
export const setPOD = (document, isPOD) => {
  document.data.podFlagSetByUser = true;
  document.is_pod = isPOD;
  document.data["includesPOD"] = document.is_pod;
};
export default { setPOD };
